import styled, { css } from "styled-components";
import ImgCard from "../../../assets/img/img-card.png";
import ImgCardGreen from "../../../assets/img/img-card-green.png";
import theme from "../../shared/theme";
export const Body = styled.div`
  width: 17.43em;
  color: #dcdcdc;
  background-image: url(${ImgCard});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  margin: 1rem;
  padding: .75rem;
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  justify-content: space-around;
  cursor: pointer;
  -webkit-filter: grayscale(100%);
	-moz-filter:    grayscale(100%);
	-ms-filter:     grayscale(100%);
	-o-filter:      grayscale(100%);
	filter: gray;
  transition: all .2s ease-in-out;
  ${props => props.selected && css`
    background-image: url(${ImgCardGreen});
    -webkit-filter: grayscale(0%);
    -moz-filter:    grayscale(0%);
    -ms-filter:     grayscale(0%);
    -o-filter:      grayscale(0%);
    filter: gray;
    cursor: pointer;
    span {
      color: ${theme.colors.greenWit};
      -webkit-text-stroke-color: ${theme.colors.greenWit};
    }
  `}
  @media screen and (min-width: 380px) {
    margin: 3rem;
  }
  :hover {
    transition: all .2s ease-in-out;
    background-image: url(${ImgCardGreen});
    -webkit-filter: grayscale(0%);
    -moz-filter:    grayscale(0%);
    -ms-filter:     grayscale(0%);
    -o-filter:      grayscale(0%);
    filter: gray;
    span {
      color: ${theme.colors.greenWit};
      -webkit-text-stroke-color: ${theme.colors.greenWit};
      transition: all .2s ease-in-out;
    }
  }
`;

export const HeaderEvent = styled.div`
  padding-bottom: .75rem;
  width: 100%;
`;

export const Span = styled.span`
  font-size: ${props => (props.size || "1em")};
  text-transform: ${props => (props.transform || "unset")};
  font-weight: 600;
  font-style: normal;
  line-height: 1.09;
  margin-left: 10px;
  letter-spacing: 1.5px;
`;

export const SpanCity = styled.h2`
  font-size: 2.5em;
  font-weight: 700;
  font-style: normal;
  line-height: 1.09;
  letter-spacing: 1.5px;
`;

export const NumberDay = styled.span`
  display: block;
  -webkit-text-stroke: 1.5px #dcdcdc;
  font-size: 4.9em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.42;
  letter-spacing: 4.09px;
  color: rgba(255, 255, 255, 0)!important;
`;

export const Month = styled.span`
  display: block;
  font-size: ${props => (props.size || "1em")};
  text-transform: ${props => (props.transform || "unset")};
  font-weight: 600;
  font-style: normal;
  line-height: 1.09;
  letter-spacing: 1.5px;
`;

export const ContentEvent = styled.div`
  padding-left: 4px;
  padding-right: 4px;
  margin-bottom: 1.4em;
`;

export const InfoEvent = styled.div`
  margin-top: 80px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
